import { ActionButton, Pie, TableComponent, TableLoader } from "components";
import {
  useAppLocation,
  useAppNavigate,
  useAppSearch,
} from "_graphql/cache/auth";
import { useUrlState, withPermissions } from "utils";

import { Action } from "components/buttons/action-button";
import AddParticipantsPercentageContainer from "../../add-percentage";
import { Colors } from "_graphql/data";
import { GetEndorsement_singleEndorsement_offer_endorsement_participants } from "_graphql/queries/__generated__/GetEndorsement";
import RemoveContainer from "../../remove-participants";
import ViewNoteContainer from "./view";
import numeral from "numeral";
import { useEndorsement } from "hooks/data/use-endorsement";

export default function OfferParticipation() {
  const [modal, setModal] = useUrlState("modal");
  const { params } = useAppLocation();
  const navigate = useAppNavigate();
  const searchParams = useAppSearch();
  const { loading, endorsement, refetch } = useEndorsement({
    offerEndorsementId: params.endorsement || "",
  });
  const dispatchAction =
    (
      id: string,
      action: Exclude<Action, "expand" | "goto">,
      participation_id?: string
    ) =>
    () => {
      navigate({
        search: (old) => ({
          ...old,
          id,
          reinsurer: participation_id?.toString(),
          modal: action,
        }),
      });
    };

  const participants =
    endorsement?.offer_endorsement_participants?.map((item, idx) => ({
      bgColor: "bg-[" + Colors[idx] + "]",
      color: Colors[idx] || "gray",
      id: item?.reinsurer?.re_company_name || "",
      label: item?.reinsurer?.re_company_name || "",
      value: item?.offer_end_participant_percentage || 0,
    })) || [];

  const sharedValue =
    endorsement?.offer_endorsement_participants?.reduce(
      (acc, curr) => acc + (curr?.offer_end_participant_percentage || 0),
      0
    ) || 0;

  return (
    <div className="grid grid-cols-4 gap-6 items-start px-3 flex-1">
      <div className="col-span-3">
        <TableComponent
          title={"participants"}
          hasSearch
          loading={loading}
          columns={[
            {
              accessor: "reinsurer.re_company_name",
              name: "Company Name",
            },
            {
              accessor: "reinsurer.re_company_email",
              name: "Company Email",
            },
            {
              accessor: "offer_end_participant_percentage",
              name: "Participant %",
            },
            {
              accessor: "",
              name: "Actions",
              render: (
                row: GetEndorsement_singleEndorsement_offer_endorsement_participants
              ) => (
                <>
                  {/* <span>{endorsement?.facultative_offer} {sharedValue} {numeral(endorsement?.facultative_offer || 0).subtract(sharedValue || 0).add(row?.offer_end_participant_percentage || 0).format("#,#.####")}</span> */}
                  {withPermissions([
                    "*:*",
                    "endorsements:*",
                    "endorsements:manage",
                    "endorsements:update",
                  ])(
                    <ActionButton
                      action={"assignPercentage"}
                      tooltip={
                        row?.offer_end_participant_percentage
                          ? "Update Percentage"
                          : "Add Percentage"
                      }
                      onClick={dispatchAction(
                        row?.offer_end_participant_id || "",
                        "assignPercentage",
                        numeral(endorsement?.facultative_offer || 0)
                          .subtract(sharedValue || 0)
                          .add(row?.offer_end_participant_percentage || 0)
                          .format("#,#.####")
                      )}
                    />
                  )}
                  {/* TODO: handle closing generation */}
                  <ActionButton
                    action={"clone"}
                    tooltip={"Generate Endorsement Closing"}
                    onClick={dispatchAction(
                      row?.offer_end_participant_id || "",
                      "clone"
                    )}
                  />
                  {withPermissions([
                    "*:*",
                    "endorsements:*",
                    "endorsements:manage",
                    "endorsements:update",
                  ])(
                    <ActionButton
                      action={"remove"}
                      tooltip={"Remove participant"}
                      onClick={dispatchAction(
                        row?.offer_end_participant_id || "",
                        "remove"
                      )}
                    />
                  )}
                </>
              ),
            },
          ]}
          data={endorsement?.offer_endorsement_participants || []}
          renderLoader={() => <TableLoader items={[1, 1, 1, 1]} />}
          refetch={refetch}
        />
      </div>
      <div className="flex flex-col items-center justify-between ">
        <span className="text-left text-sm text-secondary font-bold">
          Percentage Left:{" "}
          {(endorsement?.facultative_offer || 100) - sharedValue}
        </span>
        <div className="w-60 h-80">
          <Pie
            data={[
              ...participants,
              {
                label: "Unassigned",
                value: (endorsement?.facultative_offer || 100) - sharedValue,
                color: "#ccc",
                bgColor: "#ccc",
                id: "Unassigned",
              },
            ]}
            innerRadius={0.1}
          />
        </div>
      </div>

      <AddParticipantsPercentageContainer
        open={modal === "assignPercentage"}
        setOpen={(val: boolean) =>
          setModal(val ? "assignPercentage" : undefined)
        }
      />

      {searchParams?.id && searchParams?.modal === "remove" && (
        <>
          <RemoveContainer
            open={modal === "remove"}
            setOpen={(val: boolean) =>
              navigate({
                search: (old) => ({
                  ...old,
                  id: val ? searchParams?.id : undefined,
                  modal: val ? "remove" : undefined,
                }),
              })
            }
          />
        </>
      )}
      {searchParams?.id && searchParams?.modal === "clone" && (
        <>
          <ViewNoteContainer
            open={modal === "clone"}
            setOpen={(val: boolean) =>
              navigate({
                search: (old) => ({
                  ...old,
                  id: val ? searchParams?.id : undefined,
                  modal: val ? "clone" : undefined,
                }),
              })
            }
          />
        </>
      )}
    </div>
  );
}
